import(/* webpackMode: "eager", webpackExports: ["PostBody"] */ "/vercel/path0/app/blog/[slug]/post-body.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthPill"] */ "/vercel/path0/components/AuthPill.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
